import { render, staticRenderFns } from "./SetMetadataCarousel.vue?vue&type=template&id=29d8a1a5&scoped=true"
import script from "./SetMetadataCarousel.vue?vue&type=script&lang=js"
export * from "./SetMetadataCarousel.vue?vue&type=script&lang=js"
import style0 from "./SetMetadataCarousel.vue?vue&type=style&index=0&id=29d8a1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d8a1a5",
  null
  
)

export default component.exports